var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.currentAccount
    ? _c("div", { staticClass: "row roomy" }, [
        _c(
          "div",
          {
            staticClass:
              "margin-auto margin-bottom-4xl laptop:margin-right-0 laptop:margin-bottom-0",
          },
          [
            _c(
              "commission-card",
              {
                attrs: {
                  cost: 3000,
                  "icon-count": 1,
                  theme: _vm.theme,
                  avatar: "faStar",
                  description:
                    "Make your brand's existing logo known and accessible to millions of users by adding it to Font Awesome Free.",
                  type: "logo",
                },
              },
              [
                _c(
                  "footer",
                  {
                    staticClass: "section text-left",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c("dl", { staticClass: "padding-0 margin-0 size-sm" }, [
                      _c("dt", [_vm._v("Order ID:")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.currentOrder.number))]),
                      _vm._v(" "),
                      _c("dt", { staticClass: "sr-only" }, [
                        _vm._v("Email associated with subscription"),
                      ]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.currentAccount.email))]),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-12 laptop:column laptop:margin-left-4xl" },
          [
            _c("div", { staticClass: "margin-bottom-4xl" }, [
              _c(
                "h1",
                { staticClass: "margin-top-0 laptop:margin-bottom-md" },
                [_vm._v(_vm._s(_vm.selectedSalutation))]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "size-lg line-length-md" }, [
                _vm._v(
                  "You've commissioned your logo to be added to Font Awesome's brands icons"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "ol",
              {
                staticStyle: {
                  "--list-style-type": "none",
                  "--padding-left": "0",
                },
              },
              [
                _c(
                  "success-next-step",
                  {
                    attrs: {
                      title: "We'll Be In Touch About Next Steps",
                      "icon-name": "faHandshake",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "\n          We'll reach out to you via email shortly. We'll ask you for some details about your brand and for logo assets as well. Once we have your logo\n          coverted into an icon, you'll be able to check it out before we ship it. If you have any questions about the processing,\n          "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:icons@fontawesome.com?subject=I added my logo and have a question",
                          },
                        },
                        [_vm._v("get in touch")]
                      ),
                      _vm._v("\n          .\n        "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "success-next-step",
                  {
                    attrs: {
                      title: "Your logo will a part of Font Awesome!",
                      "icon-name": "faRocketLaunch",
                    },
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "Your logo will be added to Font Awesome. It will be bundled into our brand icons collection for all Font Awesome users to have access to."
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }